import React from 'react';
import { StyledNavIcon } from '@bit/knotchinc.web-react-components.side-nav';
import libraryIconSvg from 'images/icons/library.svg';
import AccountIconSvg from 'images/icons/account.svg';
import powerSearchIconSvg from 'images/icons/powerSearch.svg';
import entityCatalogueIconSvg from 'images/icons/entityCatalogueIcon.svg';
import reportIconSvg from 'images/icons/reportIcon-grey.svg';
import kIconSvg from 'images/icons/k.svg';
import alertsIconSvg from 'images/icons/send.svg';

export const LibraryIcon = () => <StyledNavIcon url={libraryIconSvg} />;
export const PowerSearchIcon = () => <StyledNavIcon url={powerSearchIconSvg} />;
// export const ReportIcon = () => <StyledNavIcon url={powerSearchIconSvg} />;
export const KIcon = () => <StyledNavIcon url={kIconSvg} />;
export const AccountIcon = () => <StyledNavIcon url={AccountIconSvg} />;
export const EntityCatalogueIcon = () => <StyledNavIcon url={entityCatalogueIconSvg} />;
export const ReportIcon = () => <StyledNavIcon url={reportIconSvg} />;
export const AlertsIcon = () => <StyledNavIcon url={alertsIconSvg} />;
